import { useDeviceInfo } from "./useDeviceInfo";
import React from "react";

export const useSafariPadding = () => {
  const [paddingBottom, setPaddingBottom] = React.useState(0);
  const deviceInfo = useDeviceInfo();
    
  React.useEffect(() => {
    if (
      deviceInfo.isIOS &&
      deviceInfo.isMobile && !deviceInfo.isStandalone
    ) {
      setPaddingBottom(60);
      return;
    } 
    if(deviceInfo.isIPad) {
      setPaddingBottom(60);
      return;
    }
    setPaddingBottom(0);
  }, [deviceInfo]);

  return paddingBottom;
};
